import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { UntypedFormGroup, Validators } from '@angular/forms';
import { InstanceSettings } from '../../../../models/instance/instace-setting.model';
import { JointIdValue } from '../../../../enums/joint-id.enum';
import { ActivatedRoute } from '@angular/router';
@Component({
    selector: 'app-join-id-format-details',
    templateUrl: './join-id-format-details.component.html',
    styleUrls: ['./join-id-format-details.component.scss'],
    standalone: false
})
export class JoinIdFormatDetailsComponent implements OnInit, OnChanges {
    @Input() jointIDForm: UntypedFormGroup;
    @Input() jointIDSetting: InstanceSettings;
    @Input() JointIdDropDown: InstanceSettings;
    dropDownValue: string;
    abbreviation: string = '';
    
    constructor(private route: ActivatedRoute,) { }

    async ngOnInit() {

       // const isEditInstance = this.route.snapshot.url.some(segment => segment.path === 'edit-instance');
        this.route.url.subscribe(segments => {
            const isEditInstance = segments.some(segment => segment.path === 'edit-instance');
            if (isEditInstance) {
                this.jointIDForm.disable();
            }
            else {
                this.jointIDForm.enable();
            }

        });
    }

    ngOnChanges(changes: SimpleChanges): void {        
        if (this.JointIdDropDown) {
            this.abbreviation = this.JointIdDropDown.settingValue.abbreviation;
            if (this.abbreviation == 'Auto') {
                this.jointIDForm.get('jointIDPrefix').setValidators([Validators.pattern(/^[a-zA-Z0-9\-\_\:\.]+$/)]);
                this.jointIDForm.get('jointIDPrefix').setValue(this.jointIDSetting.value ?? '');
            } else {
                this.jointIDForm.get('jointIDPrefix').clearValidators();
                this.jointIDForm.get('jointIDPrefix').reset('');
            }
        }

        this.jointIDForm.get('jointIdType').valueChanges.subscribe((res) => {
            this.abbreviation = this.JointIdDropDown.setting.settingValues.find((x) => x.settingValueId == res)?.abbreviation;
            if (this.abbreviation == 'Auto') {
                this.jointIDForm.get('jointIDPrefix').setValidators([Validators.pattern(/^[a-zA-Z0-9\-\_\:\.]+$/)]);
                this.jointIDForm.get('jointIDPrefix').setValue(this.jointIDSetting.value ?? '');
            } else {
                this.jointIDForm.get('jointIDPrefix').reset('');
            }
        }); 
    }
}
